import { render } from "./HomeSetting.vue?vue&type=template&id=5956c48f&scoped=true"
import script from "./HomeSetting.vue?vue&type=script&lang=js"
export * from "./HomeSetting.vue?vue&type=script&lang=js"

import "./HomeSetting.vue?vue&type=style&index=0&id=5956c48f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5956c48f"]])

export default __exports__